import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link as RouterLink, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import validate, { contains } from "validate.js";
import { makeStyles } from "@material-ui/styles";
import {
  Grid,
  Button,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";

import { bindActionCreators } from "redux";
import {
  tempSetUser,
  updateFirebaseRoot
} from "actions/user.js";

import md5 from 'md5';
import { SIREN_CONFIG, CONFIG_SETTINGS } from 'config.js';
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";

// const {formatMessage} = useIntl();

const schema = {
  userid: {
    presence: { allowEmpty: false, message: "^Login ID is required." },
    // presence: { allowEmpty: false, message: "^ID은 필수입니다." },
    // presence: { allowEmpty: false, message: formatMessage({id:'login_id_required'})  },
    // presence: { allowEmpty: false, message: <FormattedMessage id="login_id_required" />  },
    length: {
      maximum: 20,
    },
  },
  password: {
    // presence: { allowEmpty: false, message: "^패스워드는 필수입니다." },
    presence: { allowEmpty: false, message: "^Password is required." },
    length: {
      maximum: 20,
    },
  },
};


const SignIn = (props) => {
  const { history } = props;
  const {formatMessage} = useIntl();

  const classes = useStyles();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  });


  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState((formState) => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {},
    }));

  }, [formState.values]);


  const handleChange = (event) => {
    event.persist();

    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === "checkbox"
            ? event.target.checked
            : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }));

    // if (event.target.name === "userid")
    //   props.updateUserEmail(event.target.value);
    // else if (event.target.name === "password")
    //   props.updatePassword(event.target.value);
  };



  const doLoginWithPW = async(history, admin_id, admin_password) => {

    fetch(`${SIREN_CONFIG.HOSTNAME}/account/signin`,
    {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body:
        JSON.stringify({
          admin_id: admin_id,
          admin_password: admin_password,
        })
    })
    .then( response => {
      return response.json();
    }).then(responseData => {

      if(responseData.resultCode === '000'){
        //로그인 성공
        const newuser = {
          status: 'on',
          admin_id: responseData.admin_id,
          admin_name: responseData.admin_name,
          facility_id: responseData.facility_id,
          facility_name: responseData.facility_name,
          admin_type: responseData.admin_type,
        }

        props.tempSetUser(newuser);
        props.updateFirebaseRoot(responseData.facility_id);
        console.log("newuser: ", newuser);

        localStorage.setItem(CONFIG_SETTINGS.USER_INFO, JSON.stringify(newuser) );
        localStorage.setItem(CONFIG_SETTINGS.FIREBASE_ROOT, responseData.facility_id);

        //NOTE: 환경설정값 불러오기
        // localStorage.setItem(CONFIG_SETTINGS.DisplayDeviceHealthCheck, 'on'); //default, on
        fetch(`${SIREN_CONFIG.HOSTNAME}/settings/settings?facility_id=${responseData.facility_id}`)
        .then( res => res.json() )
        .then( snapshot => {
          if (snapshot.resultData){
            snapshot.resultData.map( (row) => {
              if (row.settingName === "displayDeviceHealthCheck") {
                localStorage.setItem(CONFIG_SETTINGS.DisplayDeviceHealthCheck, row.settingValue);
              }
            });
          }
        });


        //***** 루트로 이동
        setTimeout( () => {
          history.push('/');
          }, 500);

        // doLoginHistory(history, userEmail);

      } else {
        alert(`${formatMessage({id:'login_failed'})}\n${responseData.resultMessage}`);
        return 1;
      }
    })
    .catch( error => {
      console.error(error);
      alert( formatMessage({id:'login_failed'}) );
      return 2;
    });
  };


  const handleSignIn = (event) => {
    event.preventDefault();

    var md5_pw = md5(formState.values.password);
    doLoginWithPW(history, formState.values.userid, md5_pw);

  };


  const hasError = (field) =>
    formState.touched[field] && formState.errors[field] ? true : false;


  return (
    // <ThemeProvider theme={theme2}>
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <Grid item lg={4} md={5} xs={6}>
            <form className={classes.form} onSubmit={handleSignIn}>
              <img className={classes.logo} src="/images/logo.png" />

              <TextField
                className={classes.textField}
                error={hasError("userid")}
                fullWidth
                helperText={
                  hasError("userid") ? formState.errors.userid[0] : null
                }
                label="ID"
                name="userid"
                onChange={handleChange}
                type="text"
                value={formState.values.userid || ""}
                variant="outlined"
              />

              <TextField
                className={classes.textField}
                error={hasError("password")}
                fullWidth
                helperText={
                  hasError("password") ? formState.errors.password[0] : null
                }
                label="Password"
                name="password"
                onChange={handleChange}
                type="password"
                value={formState.values.password || ""}
                variant="outlined"
              />

              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox style={{transform:"scale(.8)"}} color="default" value="true" />
                }
                label={
                <Typography variant="caption" style={{color: '#1a1a1a'}}>Save ID</Typography>
                }
              />


              <Button
                variant="contained"
                color="primary"
                size="large"
                // className={classes.signInButton}
                className={classes.action}
                disabled={!formState.isValid}
                fullWidth
                type="submit"
              >
                LOGIN
              </Button>

            </form>
          </Grid>
        </div>
      </div>
    // </ThemeProvider>
  );
};

SignIn.propTypes = {
  history: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { updateFirebaseRoot,
      tempSetUser},
    dispatch
  );
};

let mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SignIn));


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.white,
    height: "100%",
  },

  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },

  contentContainer: {},
  content: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },

  contentBody: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
    },
  },

  label: {
    color: theme.palette.text_label_color,
  },

  // root_container:{
  //   width: "100%",
  // },

  //  grid: {
  //     height: "100%",
  //   },
  quoteContainer: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // backgroundImage: "url(/images/logo.png)",
    // backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },

  quoteInner: {
    textAlign: "center",
    flexBasis: "60px",
    backgroundImage: "url(/images/logo.png)",
    backgroundRepeat: "no-repeat",
  },
  quoteText: {
    // color: theme.palette.white,
    color: "rgba(188,0,78, 1)",
    fontWeight: 400,
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.white,
  },
  bio: {
    color: theme.palette.white,
  },

  contentHeader: {
    display: "flex",
    alignItems: "center",

    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  logoImage: {
    marginLeft: theme.spacing(4),
  },

  //가운데 정렬
  logo: {
    width:"180px",
    // width: "30%",
    // paddingLeft: theme.spacing(1),
    // paddingRight: theme.spacing(1),
    // alignItems: "center",
    // justifyContent: "center",
    display: "block",
    // position:"absolute",
    marginLeft: "auto",
    marginRight: "auto",
  },

  form: {
    paddingLeft: 60,
    paddingRight: 60,
    // paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  title: {
    marginTop: theme.spacing(3),
  },
  socialButtons: {
    marginTop: theme.spacing(3),
  },
  socialIcon: {
    marginRight: theme.spacing(1),
  },
  sugestion: {
    marginTop: theme.spacing(2),
  },
  textField: {
    marginTop: theme.spacing(2),
  },
  signInButton: {
    margin: theme.spacing(2, 0),
  },

  action: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },  
}));

